var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77082 4.71687L1.06373 7.28133C0.815004 7.57999 0.38726 7.57153 0.148292 7.26322C-0.0545418 7.00154 -0.0486537 6.61281 0.16199 6.35883L2.68977 4L0.16199 1.64117C-0.0486543 1.38719 -0.0545418 0.998464 0.148292 0.736775C0.38726 0.428469 0.815004 0.420007 1.06373 0.718666L3.77082 3.28313C3.77082 3.28313 4 3.5763 4 4C4 4.4237 3.77082 4.71687 3.77082 4.71687Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77082 4.71687L1.06373 7.28133C0.815004 7.57999 0.38726 7.57153 0.148292 7.26322C-0.0545418 7.00154 -0.0486537 6.61281 0.16199 6.35883L2.68977 4L0.16199 1.64117C-0.0486543 1.38719 -0.0545418 0.998464 0.148292 0.736775C0.38726 0.428469 0.815004 0.420007 1.06373 0.718666L3.77082 3.28313C3.77082 3.28313 4 3.5763 4 4C4 4.4237 3.77082 4.71687 3.77082 4.71687Z",
    fill: "#69707D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.983545f65615477be1f9fafcb3a824f2.svg";
export { ForwardRef as ReactComponent };